import { useTranslation } from "react-i18next";

import { LanguageWarning } from "@components/LanguageWarning";

export const FallbackLanguageWarning = () => {
  const { t } = useTranslation();

  return (
    <LanguageWarning
      labelText={t("FallbackLanguageWarning.label")}
      message={t("FallbackLanguageWarning.message")}
      pillAriaLabel={t("FallbackLanguageWarning.languagePillAriaLabel")}
      changeLanguageText={t("FallbackLanguageWarning.changeLanguage")}
      dropdownId="fallback-language-menu"
      testId="fallback-language-warning"
    />
  );
};
